import { useState, useEffect } from "react";

export default function WhatsAppWidget() {
  const [hovered, setHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const size = isMobile ? 48 : 56;
  const iconSize = isMobile ? 24 : 28;

  return (
    <div style={{
      position: "fixed",
      bottom: "24px",
      right: "24px",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "8px",
    }}>
      <div style={{
        background: "var(--plum)",
        color: "var(--white)",
        fontSize: "0.8rem",
        fontFamily: "var(--font-body)",
        padding: "6px 12px",
        borderRadius: "99px",
        whiteSpace: "nowrap",
        boxShadow: "var(--shadow-md)",
        opacity: hovered ? 1 : 0,
        transform: hovered ? "translateY(0)" : "translateY(4px)",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        pointerEvents: "none",
      }}>
        Chat on WhatsApp
      </div>
      <a
        href="https://wa.me/447533867749"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: "50%",
          background: "#25D366",
          boxShadow: hovered
            ? "0 6px 24px rgba(37,211,102,0.5)"
            : "0 4px 16px rgba(37,211,102,0.35)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          transform: hovered ? "scale(1.1)" : "scale(1)",
          color: "#fff",
          textDecoration: "none",
          flexShrink: 0,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
          <path d="M11.999 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.985-1.305A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18.182a8.17 8.17 0 01-4.162-1.136l-.298-.177-3.087.809.822-3.007-.195-.309A8.19 8.19 0 013.818 12c0-4.517 3.665-8.182 8.181-8.182 4.517 0 8.182 3.665 8.182 8.182 0 4.516-3.665 8.182-8.182 8.182z" />
        </svg>
      </a>
    </div>
  );
}
